import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {},
});

const FormattedNumberInput = ({
  className,
  classes,
  inputRef,
  name,
  onChange,
  ...rest
}) => {
  return (
    <NumberFormat
      {...rest}
      className={classNames(classes.root, className)}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
};

FormattedNumberInput.defaultProps = {
  className: '',
};

FormattedNumberInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(FormattedNumberInput);
